module.exports = __webpack_public_path__ + "media/images/platforms/ea-id/background-2843c276ecc64bd10990cfc3994dd6a1.jpg";